import { render, staticRenderFns } from "./heat.vue?vue&type=template&id=4b550a7e&scoped=true"
import script from "./heat.vue?vue&type=script&lang=js"
export * from "./heat.vue?vue&type=script&lang=js"
import style0 from "./heat.vue?vue&type=style&index=0&id=4b550a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b550a7e",
  null
  
)

export default component.exports